module.exports = __webpack_public_path__ + "img/0Q3A3733_FoamcoreMatted.7c8a96d6.jpg";